export const CATALOGUE_FALLBACK = [
  {
    "slug": "guest-amenities",
    "name": "Guest Amenities",
    "tagline": "Herbal guest toiletries & in-room kits",
    "products": [
      {
        "slug": "shampoo",
        "name": "Shampoo",
        "pack_size": "Bottle 30 ml · Bottle 20 ml · Tube 30 ml · Dispenser 350 ml · Cane 5 lt",
        "moq": "500 units",
        "visual": "bottle",
        "description": "Herbal, pH-balanced hair cleanser with a mild floral note.",
        "application": "Hotel & hospital guest rooms"
      },
      {
        "slug": "shower-gel",
        "name": "Shower Gel",
        "pack_size": "Bottle 30 ml · Bottle 20 ml · Tube 30 ml · Dispenser 350 ml · Cane 5 lt",
        "moq": "500 units",
        "visual": "bottle",
        "description": "Refreshing herbal body wash, gentle on all skin types.",
        "application": "Guest rooms & spa washrooms"
      },
      {
        "slug": "moisturiser",
        "name": "Moisturiser",
        "pack_size": "Bottle 30 ml · Bottle 20 ml · Tube 30 ml · Dispenser 350 ml · Cane 5 lt",
        "moq": "500 units",
        "visual": "tube",
        "description": "Non-greasy herbal moisturising lotion for daily use.",
        "application": "Guest vanity & amenity trays"
      },
      {
        "slug": "hair-conditioner",
        "name": "Hair Conditioner",
        "pack_size": "Bottle 30 ml · Bottle 20 ml · Tube 30 ml · Dispenser 350 ml · Cane 5 lt",
        "moq": "500 units",
        "visual": "bottle",
        "description": "Herbal conditioner for soft, manageable hair.",
        "application": "Guest rooms & spa"
      },
      {
        "slug": "glycerine-soap",
        "name": "Glycerine Soap",
        "pack_size": "20 g wrapped bar",
        "moq": "1000 units",
        "visual": "bar",
        "description": "Pure glycerine bathing bar, individually wrapped.",
        "application": "Guest rooms & patient amenities"
      },
      {
        "slug": "dental-kit",
        "name": "Dental Kit",
        "pack_size": "Toothpaste: Meswak · Toothpaste: Promise · Toothpaste: Anchor",
        "moq": "500 kits",
        "visual": "kitbox",
        "description": "Hygienically packed toothbrush with branded toothpaste — Meswak, Promise or Anchor.",
        "application": "Hotel amenity kits"
      },
      {
        "slug": "shaving-kit",
        "name": "Shaving Kit",
        "pack_size": "Oxylife gel & Dorco razor · Gillete gel & Gillet razor",
        "moq": "500 kits",
        "visual": "kitbox",
        "description": "Shaving kit combo — Oxylife gel with Dorco razor, or Gillete gel with Gillet razor.",
        "application": "Hotel amenity kits"
      },
      {
        "slug": "comb",
        "name": "Comb",
        "pack_size": "Pocket size, packed",
        "moq": "1000 units",
        "visual": "comb",
        "description": "Smooth-finish grooming comb, individually packed.",
        "application": "Vanity & amenity kits"
      },
      {
        "slug": "shoe-shiner",
        "name": "Shoe Shiner",
        "pack_size": "Sponge tin",
        "moq": "500 units",
        "visual": "tin",
        "description": "Instant-shine sponge applicator for guest footwear.",
        "application": "Amenity trays & concierge desks"
      },
      {
        "slug": "vanity-kit",
        "name": "Vanity Kit",
        "pack_size": "4-piece set",
        "moq": "500 kits",
        "visual": "kitbox",
        "description": "Cotton buds, pads & essentials in a sealed pouch.",
        "application": "Premium rooms & suites"
      }
    ]
  },
  {
    "slug": "fragrance-solutions",
    "name": "Fragrance Solutions",
    "tagline": "Aroma oils, room fresheners & diffusion systems",
    "products": [
      {
        "slug": "aroma-oil-lemon-grass",
        "name": "Aroma Oil Lemon Grass",
        "group": "Aroma Oil",
        "pack_size": "1 L amber bottle",
        "moq": "24 bottles",
        "visual": "oil",
        "description": "Aroma Oil — Crisp citrus fragrance, naturally uplifting.",
        "application": "Diffusers, lobbies & aroma programs"
      },
      {
        "slug": "aroma-oil-mogara",
        "name": "Aroma Oil Mogara",
        "group": "Aroma Oil",
        "pack_size": "1 L amber bottle",
        "moq": "24 bottles",
        "visual": "oil",
        "description": "Aroma Oil — Classic Indian jasmine-floral fragrance.",
        "application": "Diffusers, lobbies & aroma programs"
      },
      {
        "slug": "aroma-oil-lavender",
        "name": "Aroma Oil Lavender",
        "group": "Aroma Oil",
        "pack_size": "1 L amber bottle",
        "moq": "24 bottles",
        "visual": "oil",
        "description": "Aroma Oil — Calming lavender fragrance for rest environments.",
        "application": "Diffusers, lobbies & aroma programs"
      },
      {
        "slug": "aroma-oil-jasmine",
        "name": "Aroma Oil Jasmine",
        "group": "Aroma Oil",
        "pack_size": "1 L amber bottle",
        "moq": "24 bottles",
        "visual": "oil",
        "description": "Aroma Oil — Rich jasmine floral note for premium areas.",
        "application": "Diffusers, lobbies & aroma programs"
      },
      {
        "slug": "aroma-oil-oudh",
        "name": "Aroma Oil Oudh",
        "group": "Aroma Oil",
        "pack_size": "1 L amber bottle",
        "moq": "24 bottles",
        "visual": "oil",
        "description": "Aroma Oil — Deep, woody oudh for a luxury signature scent.",
        "application": "Diffusers, lobbies & aroma programs"
      },
      {
        "slug": "aroma-oil-vanilla",
        "name": "Aroma Oil Vanilla",
        "group": "Aroma Oil",
        "pack_size": "1 L amber bottle",
        "moq": "24 bottles",
        "visual": "oil",
        "description": "Aroma Oil — Warm, comforting vanilla fragrance.",
        "application": "Diffusers, lobbies & aroma programs"
      },
      {
        "slug": "aroma-oil-drakkar-noir",
        "name": "Aroma Oil Drakkar Noir",
        "group": "Aroma Oil",
        "pack_size": "1 L amber bottle",
        "moq": "24 bottles",
        "visual": "oil",
        "description": "Aroma Oil — Bold, masculine fragrance inspired by classic noir.",
        "application": "Diffusers, lobbies & aroma programs"
      },
      {
        "slug": "aroma-oil-sandal",
        "name": "Aroma Oil Sandal",
        "group": "Aroma Oil",
        "pack_size": "1 L amber bottle",
        "moq": "24 bottles",
        "visual": "oil",
        "description": "Aroma Oil — Traditional sandalwood fragrance, serene and warm.",
        "application": "Diffusers, lobbies & aroma programs"
      },
      {
        "slug": "aroma-oil-green-apple",
        "name": "Aroma Oil Green Apple",
        "group": "Aroma Oil",
        "pack_size": "1 L amber bottle",
        "moq": "24 bottles",
        "visual": "oil",
        "description": "Aroma Oil — Fresh, fruity green-apple fragrance.",
        "application": "Diffusers, lobbies & aroma programs"
      },
      {
        "slug": "room-freshener-lemon-grass",
        "name": "Room Freshener Lemon Grass",
        "group": "Room Freshener",
        "pack_size": "5 L refill can",
        "moq": "4 cans",
        "visual": "spray",
        "description": "Room Freshener — Crisp citrus fragrance, naturally uplifting.",
        "application": "Rooms, washrooms & waiting areas"
      },
      {
        "slug": "room-freshener-mogara",
        "name": "Room Freshener Mogara",
        "group": "Room Freshener",
        "pack_size": "5 L refill can",
        "moq": "4 cans",
        "visual": "spray",
        "description": "Room Freshener — Classic Indian jasmine-floral fragrance.",
        "application": "Rooms, washrooms & waiting areas"
      },
      {
        "slug": "room-freshener-lavender",
        "name": "Room Freshener Lavender",
        "group": "Room Freshener",
        "pack_size": "5 L refill can",
        "moq": "4 cans",
        "visual": "spray",
        "description": "Room Freshener — Calming lavender fragrance for rest environments.",
        "application": "Rooms, washrooms & waiting areas"
      },
      {
        "slug": "room-freshener-jasmine",
        "name": "Room Freshener Jasmine",
        "group": "Room Freshener",
        "pack_size": "5 L refill can",
        "moq": "4 cans",
        "visual": "spray",
        "description": "Room Freshener — Rich jasmine floral note for premium areas.",
        "application": "Rooms, washrooms & waiting areas"
      },
      {
        "slug": "room-freshener-oudh",
        "name": "Room Freshener Oudh",
        "group": "Room Freshener",
        "pack_size": "5 L refill can",
        "moq": "4 cans",
        "visual": "spray",
        "description": "Room Freshener — Deep, woody oudh for a luxury signature scent.",
        "application": "Rooms, washrooms & waiting areas"
      },
      {
        "slug": "room-freshener-vanilla",
        "name": "Room Freshener Vanilla",
        "group": "Room Freshener",
        "pack_size": "5 L refill can",
        "moq": "4 cans",
        "visual": "spray",
        "description": "Room Freshener — Warm, comforting vanilla fragrance.",
        "application": "Rooms, washrooms & waiting areas"
      },
      {
        "slug": "room-freshener-drakkar-noir",
        "name": "Room Freshener Drakkar Noir",
        "group": "Room Freshener",
        "pack_size": "5 L refill can",
        "moq": "4 cans",
        "visual": "spray",
        "description": "Room Freshener — Bold, masculine fragrance inspired by classic noir.",
        "application": "Rooms, washrooms & waiting areas"
      },
      {
        "slug": "room-freshener-sandal",
        "name": "Room Freshener Sandal",
        "group": "Room Freshener",
        "pack_size": "5 L refill can",
        "moq": "4 cans",
        "visual": "spray",
        "description": "Room Freshener — Traditional sandalwood fragrance, serene and warm.",
        "application": "Rooms, washrooms & waiting areas"
      },
      {
        "slug": "room-freshener-green-apple",
        "name": "Room Freshener Green Apple",
        "group": "Room Freshener",
        "pack_size": "5 L refill can",
        "moq": "4 cans",
        "visual": "spray",
        "description": "Room Freshener — Fresh, fruity green-apple fragrance.",
        "application": "Rooms, washrooms & waiting areas"
      },
      {
        "slug": "air-revitaliser",
        "name": "Air Revitaliser",
        "group": "Air Revitaliser",
        "pack_size": "Tabletop unit",
        "moq": "10 units",
        "visual": "diffuser",
        "description": "Water-based air revitaliser for purified, scented air.",
        "application": "Reception & executive cabins"
      },
      {
        "slug": "diffuser-machine",
        "name": "Diffuser Machine",
        "group": "Diffuser Machines",
        "pack_size": "HVAC / standalone",
        "moq": "5 units",
        "visual": "diffuser",
        "description": "Programmable aroma diffuser for consistent coverage.",
        "application": "Hotel lobbies & hospital atriums"
      }
    ]
  },
  {
    "slug": "housekeeping-chemicals",
    "name": "Housekeeping Chemicals",
    "tagline": "Institutional-grade cleaning chemistry",
    "products": [
      {
        "slug": "floor-cleaner",
        "name": "Floor Cleaner",
        "pack_size": "5 L can",
        "moq": "20 cans",
        "visual": "jerrycan",
        "description": "Concentrated multi-surface floor cleaner, R-series grade.",
        "application": "Corridors, wards & lobbies"
      },
      {
        "slug": "toilet-cleaner",
        "name": "Toilet Cleaner",
        "pack_size": "5 L can",
        "moq": "20 cans",
        "visual": "jerrycan",
        "description": "Heavy-duty descaling formula for sanitary ware.",
        "application": "Washrooms & utility areas"
      },
      {
        "slug": "hand-wash",
        "name": "Hand Wash",
        "pack_size": "5 L can",
        "moq": "20 cans",
        "visual": "jerrycan",
        "description": "Antibacterial herbal hand wash with moisturisers.",
        "application": "Washrooms, lobbies & wards"
      },
      {
        "slug": "wooden-polish",
        "name": "Wooden Polish",
        "pack_size": "5 L can",
        "moq": "10 cans",
        "visual": "tin",
        "description": "Nourishing polish that restores wooden surfaces.",
        "application": "Furniture, panels & doors"
      },
      {
        "slug": "dish-wash",
        "name": "Dish Wash",
        "pack_size": "5 L can",
        "moq": "20 cans",
        "visual": "jerrycan",
        "description": "High-foaming, grease-cutting dish wash concentrate.",
        "application": "Hotel & canteen kitchens"
      },
      {
        "slug": "glass-cleaner",
        "name": "Glass Cleaner",
        "pack_size": "500 ml trigger",
        "moq": "50 units",
        "visual": "spray",
        "description": "Streak-free glass & mirror cleaner, quick dry.",
        "application": "Windows, mirrors & partitions"
      }
    ]
  },
  {
    "slug": "housekeeping-tools",
    "name": "Housekeeping Tools",
    "tagline": "Mops, trolleys & daily-use equipment",
    "products": [
      {
        "slug": "dry-mop",
        "name": "Dry Mop",
        "pack_size": "24 in with handle",
        "moq": "50 units",
        "visual": "mop",
        "description": "Microfiber dry mop for dust control on all floors.",
        "application": "Corridors & lobbies"
      },
      {
        "slug": "wet-mop",
        "name": "Wet Mop",
        "pack_size": "300 g clip fit",
        "moq": "50 units",
        "visual": "mop",
        "description": "High-absorbency cotton wet mop with clip fitting.",
        "application": "Wards, rooms & wash areas"
      },
      {
        "slug": "floor-wiper",
        "name": "Floor Wiper",
        "pack_size": "18 in heavy duty",
        "moq": "50 units",
        "visual": "mop",
        "description": "Double-blade floor wiper for fast water removal.",
        "application": "Washrooms & kitchens"
      },
      {
        "slug": "wringer-trolley",
        "name": "Wringer Trolley",
        "pack_size": "36 L with wringer",
        "moq": "10 units",
        "visual": "bucket",
        "description": "Bucket trolley with down-press wringer & castors.",
        "application": "Large floor areas"
      },
      {
        "slug": "glass-cleaning-kit",
        "name": "Glass Cleaning Kit",
        "pack_size": "Squeegee + 5 L",
        "moq": "20 kits",
        "visual": "kitbox",
        "description": "Complete kit with squeegee, sleeve & concentrate.",
        "application": "Facade & glass maintenance"
      },
      {
        "slug": "caddy-bucket",
        "name": "Caddy Bucket",
        "pack_size": "Multi-compartment",
        "moq": "25 units",
        "visual": "bucket",
        "description": "Carry-all caddy for chemicals, cloths & tools.",
        "application": "Room attendants & janitors"
      },
      {
        "slug": "lobby-dustpan",
        "name": "Lobby Dustpan",
        "pack_size": "Lobby model",
        "moq": "50 units",
        "visual": "dustpan",
        "description": "Long-handle lobby dustpan for upright collection.",
        "application": "Lobbies & public areas"
      },
      {
        "slug": "garbage-bags",
        "name": "Garbage Bags",
        "pack_size": "24×32 in, roll of 20",
        "moq": "200 rolls",
        "visual": "box",
        "description": "Heavy-duty black bags for utility & wet waste.",
        "application": "Back-of-house operations"
      }
    ]
  },
  {
    "slug": "housekeeping-machines",
    "name": "Housekeeping Machines",
    "tagline": "Auto scrubbers & industrial vacuums",
    "products": [
      {
        "slug": "walk-behind-auto-scrubber",
        "name": "Walk Behind Auto Scrubber",
        "pack_size": "Battery model",
        "moq": "1 unit",
        "visual": "machine",
        "description": "Compact auto scrubber-drier for daily floor care.",
        "application": "Corridors, wards & atriums"
      },
      {
        "slug": "single-disc-machine",
        "name": "Single Disc Machine",
        "pack_size": "17 in, 1.5 HP",
        "moq": "1 unit",
        "visual": "machine",
        "description": "Single-disc scrubber & polisher for hard floors.",
        "application": "Lobbies, corridors & banquet halls"
      },
      {
        "slug": "industrial-vacuum-cleaner",
        "name": "Industrial Vacuum Cleaner",
        "pack_size": "Wet & dry, 60 L",
        "moq": "1 unit",
        "visual": "machine",
        "description": "Twin-motor wet & dry vacuum for heavy soils.",
        "application": "Banquets, kitchens & basements"
      }
    ]
  }
];
